export const isColor = (variation: string) => {
  if (!variation) return false;

  const possibleValues = [
    'cor',
    'color',
    'colour',
    'colore',
    'farbe',
    'couleur',
    'kleuren',
    'culoare',
    'värit',
    'kolory',
    'farve',
    'färger',
    'farby',
    'boje',
    'colori',
    'tsvyat',
    'Цвят',
  ];

  return possibleValues.some(value => variation.toLowerCase().includes(value));
};
